"use strict";

require("core-js/modules/es.object.assign.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FAEVoucherCard = void 0;

var _types = require("@babel/types");

var _react = _interopRequireDefault(require("react"));

var _FAEButton = require("../FAEButton/FAEButton");

var _FAEImage = require("../FAEImage/FAEImage");

var _FAEShadowBox = require("../FAEShadowBox/FAEShadowBox");

var _FAEText = require("../FAEText/FAEText");

require("./FAEVoucherCard.scss");

const _excluded = ["title", "price", "currencySymbol", "expiryDate", "buttonText", "buttonProps", "logo", "logoWidth"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

const FAEVoucherCard = _ref => {
  let {
    title,
    price,
    currencySymbol,
    expiryDate,
    buttonText,
    buttonProps,
    logo,
    logoWidth = "50px"
  } = _ref,
      rest = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_FAEShadowBox.FAEShadowBox, _extends({
    className: "fae--voucher-card-unit"
  }, rest), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--voucher-card-unit-details-wrapper"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--voucher-card-unit-title-price-expiry-date"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--voucher-card-logo-and-title"
  }, logo && /*#__PURE__*/_react.default.createElement(_FAEImage.FAEImage, {
    style: {
      width: logoWidth
    },
    src: logo,
    placeholder: _types.placeholder,
    alt: "logo"
  }), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    subHeading: true
  }, title)), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    subHeading: true,
    secondary: true
  }, currencySymbol, price)), /*#__PURE__*/_react.default.createElement("div", {
    className: "fae--voucher-card-unit-title-price-expiry-date"
  }, /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, {
    tertiary: true
  }, "Expiry: ", /*#__PURE__*/_react.default.createElement("span", null, expiryDate)), /*#__PURE__*/_react.default.createElement(_FAEText.FAEText, null, "Voucher ", /*#__PURE__*/_react.default.createElement("strong", null, "Balance")))), buttonText && /*#__PURE__*/_react.default.createElement(_FAEButton.FAEButton, _extends({}, buttonProps, {
    className: "fae--voucher-card-transfer-button"
  }), buttonText)));
};

exports.FAEVoucherCard = FAEVoucherCard;